/**
 * Configuración del evento (Feria / Cumbre Cannabis Medicinal).
 * Modifique aquí las fechas de inicio y fin para activar/desactivar el banner y pop-up.
 * El evento está ACTIVO solo cuando la fecha actual está entre inicio (inclusive) y fin (inclusive).
 *
 * PDFs: colóquelos en src/assets/invitations/ — ver LEAME.txt en esa carpeta.
 */
export interface InvitationPdfItem {
  label: string;
  bannerShortLabel?: string;
  /** Ruta dentro de assets (sin barra inicial). Debe ser archivo .pdf */
  path: string;
}

export const CANNABIS_INVITATION_CONFIG = {
  startDate: new Date(2026, 3, 13),  // 13 de abril de 2026
  endDate: new Date(2026, 3, 18),    // 18 de abril de 2026

  title: 'Feria de Salud y Cannabis Medicinal',

  shortMessage:
    'Viernes 17 de abril en Hotel Condado Plaza. Registro en Eventbrite y documentos en PDF con más detalles.',

  eventbrite: {
    url:
      'https://www.eventbrite.com/e/feria-de-salud-y-cannabis-medicinal-para-pacientes-y-publico-general-tickets-1987315553317?aff=oddtdtcreator',
    label: 'Invitación a la Feria de Salud y Cannabis Medicinal'
  },

  /** Solo PDF; deben existir en src/assets/ con el path exacto (incl. mayúsculas y espacios). */
  invitationPdfs: [
    {
      label: 'Feria de salud y cannabis medicinal',
      bannerShortLabel: 'PDF Feria de salud',
      path: 'invitations/FERIA DE SALUD CANNABIS MEDICINAL.pdf'
    },
    {
      label: '1ra Cumbre de Cannabis Medicinal (Salud, Ley y Ciencia 2026)',
      bannerShortLabel: 'PDF 1ra Cumbre',
      path: 'invitations/1ER CUMBRE DE CANNABIS MEDICINAL.pdf'
    }
  ] as InvitationPdfItem[]
};
